// extracted by mini-css-extract-plugin
module.exports = {"contactWrapper":"ContactSection_contactWrapper__2PoQa"};